import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/layout/Navbar";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@mohrengineering.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(formatApiError(e?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F8] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="mono-label text-zinc-500 hover:text-black inline-flex items-center gap-2 mb-12">
          <ArrowLeft className="w-3 h-3" /> Back to Site
        </Link>
        <div className="bg-white border border-zinc-200 p-10">
          <div className="flex items-center gap-3 mb-8">
            <LogoMark className="w-12 h-12" />
            <div>
              <div className="font-display text-2xl leading-none">Mohr</div>
              <div className="mono-label text-[10px] mt-1">Admin Console</div>
            </div>
          </div>
          <h1 className="font-display text-4xl leading-tight tracking-tight">Sign in.</h1>
          <p className="text-zinc-500 mt-2 text-sm">Administrative access only.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <label className="block">
              <span className="mono-label text-zinc-500">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border-b border-zinc-300 focus:border-black outline-none py-3 bg-transparent"
                data-testid="admin-login-email"
              />
            </label>
            <label className="block">
              <span className="mono-label text-zinc-500">Password</span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border-b border-zinc-300 focus:border-black outline-none py-3 bg-transparent"
                data-testid="admin-login-password"
              />
            </label>
            {err && <div className="text-sm text-red-700" data-testid="admin-login-error">{err}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
